import * as ExistSubscriptionActions from '../actions/existSubscription';
import subToasterContentAndTypeCreator from './subToaster/subToasterContentAndType';
import reloadExistSubscription from './reloadExistSubscription';

import * as Api from '../utils/api';
import * as Const from '../constants';

import ReduxAction from '../../../interfaces/ReduxAction';

export default function deleteExistSubscription (idReport: number): ReduxAction {
  return (dispatch): void => {
    dispatch(ExistSubscriptionActions.existSubIsLoading());

    Api.deleteExistSubscription(idReport)
      .then(() => {
        dispatch(subToasterContentAndTypeCreator(
          Const.SUBSCRIPTION_MESSAGE.delete.success,
          Const.MESSAGE_TYPE.success
        ));

        return Promise.resolve();
      })
      .catch(reason => {
        dispatch(subToasterContentAndTypeCreator(
          `${Const.SUBSCRIPTION_MESSAGE.delete.fail}. ${reason}`,
          Const.MESSAGE_TYPE.fail
        ));
        return Promise.reject();
      })

      .then(() => {
        dispatch(reloadExistSubscription());
      })
      .catch(() => {
        dispatch(ExistSubscriptionActions.existSubNotLoading());
      });
  };
}
